// 项目列表item类型
export enum EProjectItemType {
    Project = 0,    // 项目
    ScheduleGroup = 20,    // 过程调度分组
    Schedule = 21    // 过程调度
}